export * from './AbsencePeriod';
export * from './AbsencePeriodStat';
export * from './AbsencePeriodUser';
export * from './Address';
export * from './Attendance';
export * from './BookingExtendedView';
export * from './BookingPaymentTerms';
export * from './BookingView';
export * from './Convo';
export * from './ConvoMessage';
export * from './ConvoUser';
export * from './ConvoUserView';
export * from './Event';
export * from './EventAttachment';
export * from './EventAudit';
export * from './EventBulkUploadView';
export * from './EventCoHost';
export * from './EventDescriptionUtils';
export * from './EventExtendedView';
export * from './EventFeedback';
export * from './EventFeedbackAnonymousView';
export * from './EventHostView';
export * from './EventProfile';
export * from './EventRepetition';
export * from './EventSeriesReconciliationAudit';
export * from './EventUpload';
export * from './FeedbackForm';
export * from './FeedbackFormQuestion';
export * from './GroupBookingUpload';
export * from './Institution';
export * from './InstitutionGroup';
export * from './InstitutionGroupAdmin';
export * from './InstitutionGroupAttachment';
export * from './InstitutionGroupBookingView';
export * from './InstitutionGroupEvent';
export * from './InstitutionGroupEventView';
export * from './InstitutionGroupMember';
export * from './InstitutionGroupMemberUpload';
export * from './InstitutionGroupMemberView';
export * from './InstitutionGroupTimeLabel';
export * from './InstitutionMember';
export * from './InstitutionMemberInvite';
export * from './InstitutionMemberView';
export * from './InstitutionParent';
export * from './OrgUnit';
export * from './OrgUnitEvent';
export * from './OrgUnitEventView';
export * from './OrgUnitMember';
export * from './OrgUnitMemberView';
export * from './InstitutionProposal';
export * from './InstitutionView';
export * from './LivestreamBreakoutRoom';
export * from './LivestreamBreakoutRoomParticipant';
export * from './LivestreamSession';
export * from './LivestreamSessionStreamDestination';
export * from './LivestreamSessionViewer';
export * from './Location';
export * from './LocationCheckLog';
export * from './LocationTrackingSchedule';
export * from './MemberUpload';
export * from './MetricView';
export * from './OutboundEmail';
export * from './PaymentAnnualSummaryView';
export * from './PaymentIn';
export * from './PaymentOut';
export * from './PaymentSummaryView';
export * from './Person';
export * from './PushNotificationLog';
export * from './PushNotificationDeliveryStats';
export * from './PushNotificationStats';
export * from './PushRecentFailures';
export * from './PushSubscriptionHealth';
export * from './ReportEventView';
export * from './ReportGroupUserView';
export * from './ReportInstitutionGroupView';
export * from './ReportInstitutionUserView';
export * from './ReportInstitutionView';
export * from './ReportUserView';
export * from './SecurityRules';
export * from './SharedOptions';
export * from './Specialty';
export * from './TaskDefnView';
export * from './TaskGroupView';
export * from './TaskUserView';
export * from './TaskUserGroupView';
export * from './Ticket';
export * from './TicketBooking';
export * from './User';
export * from './UserByEmail';
export * from './UserSimpleView';
export * from './UserView';
export * from './VoucherCode';
export * from './VoucherProduct';
export * from './WorkflowInitiation';
export * from './WorkflowView';
export * from './legalTerms';
export * from './types';

import { Transaction } from 'gossamer-model';
import { FieldType, ReferenceField } from 'gossamer-unified';
import { UserView } from './UserView';
Transaction.fields.user_id.type = FieldType.Reference;
(Transaction.fields.user_id as ReferenceField).refEntity = UserView;
